exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-78249e80]{background:#fff;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.1);border:1px solid rgba(0,0,0,.02);padding:34px}.card[data-v-78249e80]:not(:last-child){margin-bottom:42px}.card h1[data-v-78249e80]{font-weight:700;font-size:20px;margin-bottom:4px}.card q[data-v-78249e80]{font-size:14px;opacity:.7}[data-v-78249e80] .redactor-styles{height:200px}.field--row .field-control[data-v-78249e80]{width:50%;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content}", ""]);

// exports
